import Bars from "./components/Bars";
import Backdrop from "./components/modals/Backdrop";
import Container from "./components/Container";
import Modals from "./components/modals/Modals";
import SpinnerOverlay from "./components/SpinnerOverlay";
import Div100vh from "react-div-100vh";
import LoadingScreen from "./components/LoadingScreen";
import SoundsOverlay from "./components/SoundsOverlay";
import { useAppSelector } from "./hooks";
import { useEffect } from "react";
import { PublicAPI } from "./commander";
import { getConfig, applyTheme } from "./utils";

const App = () => {
  const { gameName, theme } = useAppSelector(
    (state) => {
      return { theme: state.theme, gameName: state.details.gameName };
    },
    (o, n) => {
      return (
        o.gameName === n.gameName &&
        JSON.stringify(o.theme) === JSON.stringify(n.theme)
      );
    }
  );

  // sets the inital color theme if such
  useEffect(() => {
    const setTheme = async () => {
      const cfg = await getConfig();
      PublicAPI.setTheme(cfg.theme);
    };

    setTheme();
  }, [gameName]);

  // update the color theme, used for testing/debug
  useEffect(() => {
    applyTheme(theme)
  }, [theme]);

  // PublicAPI.test()
  return (
    <Div100vh>
      <Bars>
        <LoadingScreen />
        <SoundsOverlay />
        <Container />
      </Bars>
      <Modals />
      <SpinnerOverlay />
      <Backdrop />
    </Div100vh>
  );
}

export default App;
